import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CircularProgress from '@material-ui/core/CircularProgress';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import { Button } from '@material-ui/core';
import { Dialog } from '@material-ui/core';
import { DialogContent } from '@material-ui/core';
import { DialogContentText } from '@material-ui/core';
import { DialogActions } from '@material-ui/core';
import { Checkbox } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    registroFacturas: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 50,
        paddingBottom: 50
    },
    titulo: {
        margin: 20,
        width: '55%',
        textAlign: 'left'
    },
    factura: {
        width: '60%'
    },
    resumen: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignContent: 'center'
    },
    panel: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    detalles: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignContent: 'center'
    },
    opciones: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignContent: 'space-between'
    },
    check: {
        alignSelf: 'center',
        height: 'fit-content',
        width: 'fit-content'
    },
    delete: {
        alignSelf: 'center',
        height: 'fit-content',
        width: 'fit-content'
    }
}));

export default function RegistroFacturas(props) {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [borrar, setBorrar] = useState(null);
    const [expanded, setExpanded] = useState(false);
    const [load, setLoad] = useState(false);
    const [solicitudes, setSolicitudes] = useState([]);
    //codigo sacado de los faqs de React
    useEffect(() => {
        let ignore = false;

        async function getSolicitudes() {
            const response = await fetch('https://icsa-server.herokuapp.com/facturas');
            const jsonResponse = await response.json();
            if (!ignore) setSolicitudes(jsonResponse);
        }
        getSolicitudes();
        return () => {
            ignore = true;
            setLoad(true);
        }
    }, [props.user.email, load]);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    async function handleCheck (index) {
        let bool = solicitudes[index].hecha === 1 ? 0 : 1;
        let id = solicitudes[index].id;

        let params = {
            hecha: bool
        };
        console.log(params);
        const response = await fetch(`https://icsa-server.herokuapp.com/facturas/${id}`, {
            method: 'PUT',
            body: JSON.stringify(params),
            headers: {
                "Content-type": "application/json"
            }
        });
        console.log(response);
        if (response.ok) {
            setLoad(false);
        }
    }

    function confirmarBorrarSolicitud (id) {
        setBorrar(id);
        setOpen(true);
    }

    async function borrarSolicitud() {
        const response = await fetch(`https://icsa-server.herokuapp.com/facturas/${borrar}`, {
            method: 'DELETE',
            headers: {
                "Content-type": "application/json"
            }
        });
        console.log(response);
        if (response.status === 200) {
            setOpen(false);
            setLoad(false);
        }
    }

    return (
        <Container className={classes.registroFacturas}>
            <Typography variant="h4" className={classes.titulo}>Solicitudes registradas</Typography>
            {solicitudes.length > 0 ? solicitudes.map((solicitud, index) => {
                let fecha = new Date(solicitud.fecha);
                return (
                    <ExpansionPanel className={classes.factura}
                        key={`panel${index}`}
                        expanded={expanded === `panel${index}`}
                        onChange={handleChange(`panel${index}`)}
                    >
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{ content: classes.resumen }}>
                            <Typography variant="h6">
                                Factura a <b>{solicitud.receptor}</b>.
                            </Typography>
                            <Typography variant="h6">
                                <b>{`${fecha.getDate()}/${fecha.getMonth() + 1}/${fecha.getFullYear()}`}</b>
                            </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Container className={classes.detalles}>
                                <Typography align='left' variant="body1"><b>Solicitada por:</b> {solicitud.nombre}</Typography>
                                <Typography align='left' variant="body1"><b>Proyecto:</b> {solicitud.proyecto}</Typography>
                                <Typography align='left' variant="body1"><b>Moneda:</b> {solicitud.moneda}</Typography>
                                <Typography align='left' variant="body1"><b>Monto:</b> {solicitud.monto}</Typography>
                                <Typography align='left' variant="body1"><b>I.V.A.:</b> {solicitud.iva}</Typography>
                                <Typography align='left' variant="body1"><b>Total:</b> {solicitud.total}</Typography>
                                <Typography align='left' variant="body1"><b>Detalle:</b> {solicitud.detalle}</Typography>
                            </Container>
                            <Container className={classes.opciones}>
                                <Checkbox color="primary" className={classes.check} checked={solicitud.hecha === 1 ? true : false} onClick={() => handleCheck(index)}/>
                                <IconButton onClick={() => confirmarBorrarSolicitud(solicitud.id)} aria-label="delete" className={classes.delete}>
                                    <DeleteIcon />
                                </IconButton>
                            </Container>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                );
            }) : <CircularProgress color="primary" />}
            <Dialog onClose={() => setOpen(false)} open={open}>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        ¿Desea borrar esta factura?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="primary">
                        No
                    </Button>
                    <Button onClick={borrarSolicitud} color="primary">
                        Sí
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}